import React from 'react'
import "./Bmt2.css"

function Bmt2() {
    return (
        <div>
            
        </div>
    )
}

export default Bmt2
